import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SzBrandBlockComponent, SzIconComponent } from '@ui';
import { NAVIGATION_TOKEN, NavigationProvider } from '@core';

@Component({
  selector: 'app-legal-privacy-page',
  templateUrl: './legal-privacy.page.html',
  styleUrls: ['./legal.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzBrandBlockComponent, SzIconComponent]
})
export class LegalPrivacyPage {
  private readonly navigation: NavigationProvider = inject(NAVIGATION_TOKEN);

  goBack(): void {
    this.navigation.back();
  }
}
